<template>
  <div>
    <transition name="modal__fade">
      <div :class="'modal__backdrop modal__backdrop__' + mode" @click="close">
        <div :class="{'modal' : true, 'modalThreed' : isModeThreeD }"
             :style="getStyle"
             role="dialog"
             aria-labelledby="information"
             aria-describedby="content"
             @click.stop="$emit('clickInside', $event)"
        >
          <button
            v-if="showBackButton"
            type="button"
            class="modal__close"
            aria-label="Close modal"
            @click="close"
          >
            <Cross :width="14" :height="14" />
          </button>

          <div :class="{ 'modal__content' : mode !== 'onlinebooking', 'modal__content__onlinebooking' : mode === 'onlinebooking' }">
            <slot name="content">
              add content
            </slot>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Cross from './icons/Cross.vue';

export default {
  name: 'Modal',
  provide() {
    return {
      $validator: this.validator || this.$parent.$parent.$validator,
    };
  },
  components: {
    Cross,
  },
  inject: ['$validator'],
  props: {
    validator: { required: false },
    showBackButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    clickToClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    mode: {
      type: String,
      required: false,
      default: 'normal',
    },
    bgStyle: { type: Object, default: () => {} },
  },
  mounted() {
    // Add event listener for keydown event
    window.addEventListener('keydown', this.handleKeyDown);
  },

  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  computed: {
    isModeThreeD() {
      return (this.mode == 'threed');
    },
    getStyle() {
      return this.bgStyle != {} ? this.bgStyle : { background: '#fff' };
    },
  },
  methods: {
    close() {
      if (this.clickToClose) {
        this.$emit('close');
      }
    },
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        // Key is ESC, call the close method
        this.close();
      }
    },
  },

};
</script>

<style lang="scss">
@import '../assets/styles/settings/config.scss';
@import '../assets/styles/components/modals.scss';

.modalThreed {
  width:470px;
  height: 500px;
  @include mobile-down {
    height: 70% !important;
  }
}

.modal {
  background: $stoneWhite;
  box-shadow:(0px 3px 2px rgba($black, 0.15));
  display: flex;
  flex-direction: column;
  width: 500px;
  max-height: 90vh;
  z-index: 2500;
  position: relative;

  @include mobile-down {
    margin: 0;
    max-width: 100vw;
    max-height: 100vh;
  }
  // adding smooth transition to open and close
  &__fade {
    &-enter,
    &-leave-active {
      opacity: 0;
    }
    &-enter-active,
    &-leave-active {
      transition: opacity 0.7s ease
    }
  }
  &__backdrop {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-transform: translate3d(0,0,0);
    z-index: 1001;

    &__blurred
    {
      backdrop-filter: blur(10px);
    }
  }

  &__close {
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    text-align: right;
    padding: 8px;
    background: transparent;
    position: absolute;
    right: 0;

  }
  &__content {
    // I want to remove center but need to see where it is effected - julia
    text-align: center;
    padding: 20px;
    height: 100%;
    @include mobile-down {
      padding: 10px;
      // max-height: 500px;
      overflow-y: auto;
    }
  }
  &__mobile-close {
    display: none;
    @include mobile-down {
      display: block;
      border-top: 1px solid $echo-blue;
      justify-content: flex-end;
      padding: 10px;
      text-align: center;
      font-weight: 500;
      button {
        color: $darkBlack;
      }
    }
  }
  &__content__onlinebooking {
    text-align: center;
    padding: 20px;
    height: 100%;
    @include mobile-down {
      overflow-y: scroll;
    }
  }

}

.video__modal .modal {
  width: auto;
  height: auto;

  &__content {
    padding: 30px;

    @include mobile-down {
      padding: 0;
      width: 103%;
    }

    .modal__readMore--body {
      max-height: max-content;

      iframe {
        @include mobile-down {
          width: 100%;
        }
      }
    }
  }
}

.newsletter__modal .modal {
  @include mobile-down {
    max-height: 435px;
  }
}

</style>
